module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAIBAMAAAA7P9P/AAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMA1BaqzBXDu9m162wToAAAADVJREFUCNdjSDQ2NrYsb2PwWgUCSxgUwbQQA5MUkFqowAAWEGVgAAksDGAAAkUQFyTgAuQCAMqHEjKeWsWBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiangxia.png
// module id = uJim
// module chunks = 21